import React from "react";
import {
  ASSIGNMENT_STATUS_COLORS,
  ASSIGNMENT_STATUS_LABELS,
} from "../../utils/markschedule/marksConstants";
import { Badge } from "../../components/ui";

export default function AssignmentStatusBadge({ status }) {
  const cls = ASSIGNMENT_STATUS_COLORS[status] || "bg-neutral-100 dark:bg-neutral-800 text-neutral-600 dark:text-neutral-300 border-neutral-200 dark:border-neutral-800";
  const label = ASSIGNMENT_STATUS_LABELS[status] || status || "—";

  return (
    <Badge className={`inline-flex items-center border font-medium ${cls}`}>
      {label}
    </Badge>
  );
}